
import React, { useState } from 'react';
import PolicyModal from './PolicyModal';

const Footer: React.FC = () => {
  const [modalType, setModalType] = useState<'agreement' | 'privacy' | null>(null);

  return (
    <>
      <footer className="bg-white border-t border-gray-200 py-12 mt-12">
        <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm">
          <div>
            <h5 className="font-bold text-gray-900 mb-4">Maker Story</h5>
            <p className="text-gray-500 mb-4">
              상상하는 모든 것을 만드는 즐거움.<br/>
              대한민국 No.1 메이커 스페이스 쇼핑몰
            </p>
            
            {/* Agreement & Privacy Policy Buttons */}
            <div className="flex gap-3 items-center">
              <button 
                onClick={() => setModalType('agreement')}
                className="text-[10px] font-bold text-gray-400 hover:text-indigo-600 transition uppercase tracking-wide border-b border-transparent hover:border-indigo-600 pb-0.5"
              >
                Agreement
              </button>
              <span className="text-[10px] text-gray-300">|</span>
              <button 
                onClick={() => setModalType('privacy')}
                className="text-[10px] font-bold text-gray-400 hover:text-indigo-600 transition uppercase tracking-wide border-b border-transparent hover:border-indigo-600 pb-0.5"
              >
                Privacy Policy
              </button>
            </div>
          </div>
          <div>
            <h5 className="font-bold text-gray-900 mb-4">배송 및 고객문의</h5>
            <p className="text-gray-500 mb-1">평균 3~5일 영업일 이내 배송</p>
            <div className="flex items-center gap-2 flex-wrap mb-1">
              <p className="text-gray-500">053-811-8922 /</p>
              <a 
                href="https://pf.kakao.com/_juYQn" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 px-3 py-1 bg-[#FEE500] text-[#191919] rounded-lg font-black text-[10px] hover:brightness-95 transition-all shadow-sm group"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5 group-hover:scale-110 transition-transform">
                  <path d="M12 3c-4.97 0-9 3.185-9 7.115 0 2.558 1.712 4.8 4.312 6.095l-1.09 3.993c-.056.206.19.378.358.26l4.734-3.136c.224.015.451.023.686.023 4.97 0 9-3.185 9-7.115S16.97 3 12 3z" />
                </svg>
                채널추가
              </a>
            </div>
            <p className="text-gray-500">평일 10:00 - 16:00 (주말/공휴일 휴무)</p>
          </div>
          <div>
            <h5 className="font-bold text-gray-900 mb-4">사업자 정보</h5>
            <p className="text-gray-500">메이커스토리 / 대표 : 김향란</p>
            <p className="text-gray-500">사업자번호 : 661-62-00744</p>
            <p className="text-gray-500">통신판매업 : 제2026-대구수성구-0065호</p>
            <p className="text-gray-500">주소 : 대구 수성구 달구벌대로 3125 2F</p>
          </div>
        </div>
      </footer>

      {/* Policy Modal Overlay */}
      {modalType && (
        <PolicyModal 
          type={modalType} 
          onClose={() => setModalType(null)} 
        />
      )}
    </>
  );
};

export default Footer;
